import { combineReducers } from 'redux';
import { routerReducer as routing } from 'react-router-redux';
import { sessionReducer } from 'redux-react-session';
import { default as userLogin } from './login';
import { default as notifications } from './notifications';
import { default as project } from "./project";
import { default as agreements } from "./agreements";
import { default as dispersions } from "./dispersions";
import { default as projects } from "./projects";
import { default as profile } from './profile';
import { default as versions } from './versions';
import { default as version_groups_phases } from './version_groups_phases';
import { default as phases } from './phases';
import { default as groupsPhases } from './groups_phases';
import { default as documents_types} from './documents_types';
import { default as goals } from './goals';
import { default as permissions } from "./permissions";
import { default as roles } from "./roles";
import { default as users } from "./users";
import { default as status } from './status';
import { default as objectives} from './objectives';
import { default as strategies} from './strategies';
import { default as axis } from './axis';
import { default as lines } from './lines';
import { default as activities } from './activities';
import { default as concepts } from './concepts';
import { default as units } from './units';
import { default as modal } from './modal';
import { default as verificationMedia } from './verification_media';
import { default as activityGroup } from './activity_groups';
import { default as entities } from "./entities";
import { default as municipalities } from "./municipalities";
import { default as agencies } from "./agencies";
import { default as amounts_agencies } from "./amounts_agencies";
import { default as directories } from './directories';
import { default as modalities } from './modalities';
import { default as resource_concepts } from "./resource_concept";
import { default as revision } from "./revision";
import { default as notification_messages } from "./notification_messages";
import { default as notifications_types } from "./notifications_types";
import { default as surveys } from './surveys';
import { default as reports } from './reports';
import { default as register } from './register';
import { default as menu } from './menu';
import { default as cdms } from './cdms';
import { createForms } from "react-redux-form";

const rootReducer = combineReducers({
	session: sessionReducer,
	menu,
	userLogin,
	register,
	notifications,
	profile,
	project,
	projects,
	cdms,
	agreements,
	dispersions,
	revision,
	reports,
	notification_messages,
	notifications_types,
	surveys,
	entities,
	municipalities,
	versions,
	version_groups_phases,
	phases,
	groupsPhases,
	documents_types,
	goals,
	permissions,
	roles,
	users,
	status,
	objectives,
	strategies,
	axis,
	lines,
	activities,
	concepts,
	units,
	agencies,
	amounts_agencies,
	modal,
	verificationMedia,
	activityGroup,
	directories,
	modalities,
	resource_concepts,
	...createForms({
		profile: profile,
		roles: roles,
		objectives: objectives,
		strategies: strategies,
		lines: lines,
		axis: axis,
		activities: activities,
		goals:goals,
		users: users,
		concepts:concepts,
		units: units,
		project: project,
		projects: projects,
		cdms: cdms,
		agreements: agreements,
		dispersions: dispersions,
		permissions: permissions,
		entities: entities,
		municipalities: municipalities,
		agencies: agencies,
		amounts_agencies: amounts_agencies,
		revision: revision,
		notification_messages: notification_messages,
		notifications_types: notifications_types,
		surveys: surveys,
		groupsPhases: groupsPhases,
		phases: phases,
		versions: versions,
		version_groups_phases: version_groups_phases,
		reports: reports,
		register: register
	}),
	routing
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js